import { createContext } from "react";

/**
 * How buttons present themselves in the region they're composed into.
 *
 * A compact icon row (the bubble menu) and a labelled dropdown list (the
 * format selector) want different things from the same button, and the
 * container is what knows which it is — so it declares it once here rather
 * than every button carrying a `hideName` prop the caller has to repeat.
 */
export type EditorToolbarValue = {
  /** Render each button's name beside its icon. */
  labels: boolean;
  /**
   * Run after a button's command. A region that opened in a popup uses this to
   * dismiss itself: a block format changes the line height, the bubble menu
   * re-anchors to the new selection rect, and a dropdown still open rides
   * along with it — which reads as the menu jumping away from the pointer.
   */
  onCommand?: () => void;
};

export const EditorToolbarContext = createContext<EditorToolbarValue>({ labels: false });
